import React from 'react';
import { Grid } from '@mui/material';

const ScaleHeader = ({ value, setValue, isReadOnly, onFocus, handleClickOutside, handleHeadingFocus, HeadingColor }) => (
    <Grid className="HeadingInput" pb="14px">
        <input className="customHead-input" placeholder={'یک عنوان وارد کنید'} style={{
            border: 'none',
            outline: 'none',
            userSelect: 'text',
            wordWrap: 'break-word',
            whiteSpace: 'pre-wrap',
            width: '100%',
            fontSize: '16px',
            fontWeight: 700,
            lineHeight: 1.45,
            color: HeadingColor,
            '::placeholder': {
                color: '#b8bdc9',
            },
        }}
            readOnly={isReadOnly}
            value={value}
            onChange={(e) => setValue(e.target.value)}
            onClick={handleClickOutside}
            onFocus={isReadOnly ? null : handleHeadingFocus}
        />
    </Grid>
);

export default ScaleHeader;
